// CSS 
import "@/assets/css/general.scss";
import "@/assets/responsive/main-layout.scss";
//Lib 
import {
  mapState
} from "vuex";

// Event, Dialog 
import EventBus from "@/event/EventBus";

// Api 

// Constant 
import {
  ROUTE_URL
} from '@/constant/route';

// Extend
import base from '@/scripts/base';

// Components 
import ToolBar from "@/views/component/ToolBar";
import Footer from "@/views/component/Footer";
import HeaderNews from "@/views/component/HeaderNews";
import ExtraServiceOpenPort from "@/views/modal/ExtraService/ExtraServiceOpenPort";
import RateImage from "@/views/Rating/RateImage";
import Promotion from "@/views/modal/Promotion";
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
const io = require("socket.io-client");
const clientappSocketUrl = process.env.VUE_APP_SOCKET_CLIENT_APP_URL;
export default {

  extends: base,

  components: {
    ToolBar,
    Footer,
    HeaderNews,
    ExtraServiceOpenPort,
    RateImage,

    downloadPopup: lazyLoadComponent({
      componentFactory: () => import("@/views/common/Download"),
      loading: SkeletonBox
    }),
    maintainAnnouncementsPopup: lazyLoadComponent({
      componentFactory: () => import("@/views/common/Maintain"),
      loading: SkeletonBox
    }),
    Promotion,
  },

  data() {
    return {
      clientGloabalSocket: null,
      isCollapse: true,

      currentInvoice: {},
      currentService: {},
      createImageRequest: {},
      createImageType: 0,

      navActive: ROUTE_URL.DASHBOARD,

      routeParam: null,
      targetPopup: null,

      promotionKey: 0,
      extraServiceOpenPortKey: 0,
      chatwootReady: false,
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },

  watch: {
    $route(to, from) {
      this.navActive = this.$route.path.substring(1);
    },
    chatwootReady(){
      console.log('watch this.chatwootReady', this.chatwootReady);
    },
    user: {
      handler: function (val, oldVal) {   
        if(this.user.email){          
          if(window.chatTool ==="chatwood"){
            window.$chatwoot.setUser(this.user.userId, {
              email: this.user.email,
              name: this.user.username,
              avatar_url: this.user.profilePhoto,
              phone_number: this.user.phone,
              country_code: this.user.region,
            });
          }
        }  
        if(window.chatTool ==="tawk.to"){
          this.$Tawk.$updateChatUser({
            name: this.user.username,
            email: this.user.email,
            hash: '' // see more https://www.tawk.to/javascript-api/#securemode
          });
        }   
      },
      deep: true
    }
  },

  created() {
    window.addEventListener('chatwoot:ready', function () {
      this.chatwootReady = true;
    });
    this.navActive = this.$route.path.substring(1);

    this.getCommonInformation();

    EventBus.$on("openPopup", this.openPopup1);
    EventBus.$on("processingEventApp", this.processingEvent);
  },
  beforeDestroy() {
    EventBus.$off("openPopup");
    EventBus.$off("processingEventApp");
  },
  mounted() {
    setInterval(() => {
      this.getCommonInformation();
    }, 30000);
    this.clientGloabalSocket = io(clientappSocketUrl, {
        forceNew: true
    });
    
    this.clientGloabalSocket.on("STRANGE_DEVICE_LOGIN", (data) => {
      console.log("STRANGE_DEVICE_LOGIN:", data)
    });

    this.clientGloabalSocket.on("close", this.tryReconnect);
    this.clientGloabalSocket.on("connection", (socket) => {
      this.clientGloabalSocket.emit("login", {
          id: localStorage.getItem('userId')
      });
    });
    this.clientGloabalSocket.connect();
  },

  methods: {
    tryReconnect() {
      setTimeout(() => {
          this.clientGloabalSocket.io.open((err) => {
              if (err) {
                  this.tryReconnect();
              }
          });
      }, 2000);
    }, 
    goQuickStart() {
        if (this.user.region === 'VN') {
            window.open('https://irender.vn/huong-dan-su-dung-chi-tiet-dich-vu-gpuhub/', '_blank');
        } else {
            window.open('https://docs.gpuhub.net/workflow/1-register/', '_blank');
        }
        this.matomoLog('HeaderBar', 'Click', 'Quick start');
    },

    goDocuments() {
        window.open('https://docs.gpuhub.net/', '_blank');
    },
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    //#region Open pop-up
    processOpenPopup(param) {
      this.targetPopup = param.data;
      this.openPopup(param.type);
    },
    //#endregion

    //#region Collapse nav
    collapseNav() {
      this.isCollapse = !this.isCollapse;
    },
    //#endregion

    //#region Change route param
    changeRouteParam(param) {
      this.routeParam = param;
    },
    //#endregion

    getCommonInformation() {
      this.$store.dispatch("auth/basicUserInformationView");
      this.$store.dispatch("auth/getTempBalance");
      this.$store.dispatch("common/serverReportView");
    },

    // Open pop-up
    openPopup1(param) {
      $(`#${param.type}`).modal({
        keyboard: true
      });
      switch (param.type) {
        case "invoice":
          this.currentInvoice = param.data;
          this.invoiceKey += 1;
          break;
      }
    },

    // Close pop-up
    closePopup(popup) {
      $(`#${popup}`).modal("hide");
      setTimeout(() => {
        switch (popup) {
          case "download":
            this.modalCenterDownload = "";
            break;
        }
      }, 300);
    },
  },
};